import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
const TareaDetalleSolicitud = React.lazy(
  () =>
    import("../components/task/accountManager/tareaDetalleSolicitud/tarea-detalle-solicitud"),
);
const ErrorPage = React.lazy(() => import("../components/error-page"));

export function tareaDetalleSolicitud() {
  return (
    <Route
      path="/tarea-detalle-solicitud"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleSolicitud />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
